const component = require('../component/component');

const multi = Object.assign({}, component, {
    getSubcomponent: function (subcomponentId) {
        let elementKey = this.elementKey();
        let id = elementKey !== false ? this.id.replace('_' + elementKey, '') : this.id;
        let suffix = elementKey !== false ? '_' + elementKey : '';

        return this.hm.app.getComponent(id + '_' + subcomponentId + suffix);
    },

    getValue: function () {
        return false;
    },

    getSubcomponents: function () {
        let subComponents = {};
        let elementKey = this.elementKey();
        let id = elementKey !== false ? this.id.replace('_' + elementKey, '') : this.id;
        let suffix = elementKey !== false ? '_' + elementKey : '';
        let subComponentsElements = this.element.querySelectorAll('[data-zit-component]');

        subComponentsElements.forEach((subComponentsElement) => {
            if (typeof this.hm.app.components[subComponentsElement.id] !== typeof undefined) {
                let subcomponentId = subComponentsElement.id.substring(id.length + 1, subComponentsElement.id.length - suffix.length);
                subComponents[subcomponentId] = this.hm.app.components[subComponentsElement.id];
            }
        });

        return subComponents;
    },

    disable: function () {
        let subComponents = this.getSubcomponents();

        for (let subcomponentId in subComponents) {
            subComponents[subcomponentId].disable();
        }
        component.disable.call(this);
    },

    enable: function () {
        let subComponents = this.getSubcomponents();

        for (let subcomponentId in subComponents) {
            subComponents[subcomponentId].enable();
        }
        component.enable.call(this);
    },
});

module.exports = multi;